<template>
  <div>
    <!--
      Code By     : 陈伦刚
      CreateTime  : 2021-05-31 02:13:08
      Description : 收藏
    -->
    <div class="page">
      <div class="select-page">
        <div
          class="item"
          :class="{ active: selectActive === 0 }"
          @click="selectClick(0)"
        >
          作品
        </div>
        <div
          class="item"
          :class="{ active: selectActive === 3 }"
          @click="selectClick(3)"
        >
          素材
        </div>
        <div
          class="item"
          :class="{ active: selectActive === 4 }"
          @click="selectClick(4)"
        >
          学院（教程）
        </div>
        <!-- <div
          class="item"
          :class="{ active: selectActive === 6 }"
          @click="selectClick(6)"
        >
          Gaia48
        </div> -->
      </div>
      <!-- 右侧筛选栏 -->
      <div class="select">
        <img
          src="@/assets/icon/reset.png"
          style="margin: 4px 10px 0 0; cursor: pointer"
          @click="reset"
        />
        <img
          v-if="isSelf"
          style="cursor: pointer; margin-right: 6px; user-select: none"
          :src="url + '/web/img/me_settings_n.png'"
          @click="openReview"
        />
        <el-button
          v-if="isSelf && [0, 1, 2, 3, 5].includes(selectActive)"
          type="primary"
          size="small"
          icon="el-icon-s-operation"
          style="vertical-align: top; padding: 8px 15px; margin: 1px 6px 0 0"
          @click="openManage"
        >
          批量管理
        </el-button>
        <el-select
          v-if="[1, 2].includes(selectActive)"
          v-model="see"
          size="small"
          style="width: 120px; vertical-align: top; margin-right: 4px"
          @change="getList()"
        >
          <el-option label="全部" value="" />
          <el-option label="免费观看" value="free" />
          <el-option label="付费观看" value="pay" />
        </el-select>
        <el-select
          v-if="[4].includes(selectActive)"
          v-model="courseType"
          size="small"
          style="width: 120px; vertical-align: top; margin-right: 4px"
          @change="getList()"
        >
          <el-option label="全部教学" value="" />
          <el-option label="视频教学" value="video" />
          <el-option label="图文教学" value="imgAndText" />
        </el-select>
        <el-select
          v-if="[0].includes(selectActive)"
          v-model="colorEnhancement"
          size="small"
          style="width: 130px; vertical-align: top; margin-right: 4px"
          @change="getList()"
        >
          <el-option label="全部动态范围" value="" />
          <el-option label="HDR" value="HDR" />
          <el-option label="Dolby Vision" value="4.0" />
          <el-option label="HED10" value="hed10" />
          <el-option label="HED10+" value="hed10+" />
          <el-option label="HED12" value="hed12" />
          <el-option label="HED12+" value="hed10+" />
          <el-option label="HLG" value="hlg" />
          <el-option label="HLG12" value="hlg12" />
        </el-select>
        <el-select
          v-if="[0].includes(selectActive)"
          v-model="allowDownload"
          size="small"
          style="width: 120px; vertical-align: top; margin-right: 4px"
          @change="getList()"
        >
          <el-option label="全部" value="" />
          <el-option label="允许下载" :value="true" />
          <el-option label="不允许下载" :value="false" />
        </el-select>
        <el-select
          v-if="[0, 1, 2].includes(selectActive)"
          v-model="sort"
          size="small"
          style="width: 120px; vertical-align: top"
          @change="getList()"
        >
          <el-option label="发布时间" value="time" />
          <el-option label="播放次数" value="playCount" />
        </el-select>
        <el-select
          v-if="[3].includes(selectActive)"
          v-model="MemberType"
          size="small"
          style="width: 120px; vertical-align: top"
          @change="getList()"
        >
          <el-option label="全部素材" value="" />
          <el-option label="视频素材" value="video" />
          <el-option label="图片素材" value="picture" />
          <el-option label="音频素材" value="music" />
          <el-option label="模板素材" value="template" />
          <el-option label="其他素材" value="other" />
        </el-select>
        <el-select
          v-if="[6].includes(selectActive)"
          v-model="areaId"
          placeholder="请选择区域"
          size="small"
          style="width: 320px; vertical-align: top"
          @change="getList()"
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="`${item.text} | ${item.pinyin} | ${item.startTime} - ${item.endTime}`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="all-works">
      <div v-loading="loading" style="height: 50px"></div>
      <div
        v-if="!loading && page.total === 0"
        style="text-align: center; font-size: 12px; color: #999999"
      >
        暂无作品信息
      </div>
      <works-card
        v-if="selectActive === 0"
        class="item"
        v-for="(item, i) in worksList"
        :key="item.id"
        :data="item"
        :isSelf="isSelf"
        :showUser="true"
        @click="open(`/works/player/${item.id}`)"
      />
      <hdr-card
        v-if="selectActive === 1"
        class="item"
        v-for="(item, i) in hdrsList"
        :key="item.id"
        :data="item"
        :isSelf="isSelf"
        @click="open(`/works/hdrplayer/${item.id}`)"
      />
      <hdr-card
        v-if="selectActive === 2"
        class="item"
        v-for="(item, i) in showsList"
        :key="item.id"
        :data="item"
        :isSelf="isSelf"
        @click="open(`/works/showplayer/${item.id}`)"
      />
      <material-card
        v-if="selectActive === 3"
        class="item"
        style="margin-bottom: 50px"
        v-for="(item, i) in materialsList"
        :key="item.id"
        :style="{ marginRight: (i + 1) % 4 !== 0 ? '16px' : '0' }"
        :data="item"
        :showPrice="false"
        @click="materialClick(item.material.id, item.material.contentType)"
      />
      <academy-card
        v-if="selectActive === 4"
        class="item"
        v-for="(item, i) in courseList"
        :key="item.id"
        :style="{ marginRight: (i + 1) % 4 !== 0 ? '32px' : '0' }"
        :data="item"
        :isSelf="false"
        @click="open(`/college/private/courseDetail?id=${item.id}`)"
      />
      <works-card
        v-if="selectActive === 5"
        class="item"
        v-for="(item, i) in courseCworksList"
        :key="item.id"
        :data="item"
        :isSelf="isSelf"
        @click="open(`/college/private/personalPlay/${item.id}`)"
      />
      <gaia-48-card
        v-if="selectActive === 6"
        class="item2"
        v-for="(item, i) in gaia48List"
        :key="item.id"
        :data="item"
      />
      <div style="padding-top: 80px; text-align: center">
        <el-pagination
          background
          v-if="page.total > 0"
          layout="prev, pager, next"
          :disabled="loading"
          :page-size="page.pageSize"
          :total="page.total"
          :current-page="page.pageIndex"
          @current-change="getList"
        />
      </div>
    </div>
    <!-- <div class="all-works" v-if="selectActive === 6">
      <div class="item" v-for="(item, i) in [1, 2, 3, 4]">
        <div class="cover"></div>
        <thumbs-up
          theme="outline"
          size="40"
          fill="#FFA100"
          style="cursor: pointer"
        />
        <div class="votes">投票 (512)</div>
        <div class="title">西域大漠归来</div>
        <div class="number">No. 166</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  collections,
  getHdrList,
  getShowList,
  getPersonalCollectMaterial,
  personalCollect,
  personalCworksList,
  getPersonal48Works,
} from "@/api/personal";
import { ThumbsUp } from "@icon-park/vue";
import { getAreas } from "@/api/newgaia48";
import WorksCard from "@/components/work-card/works-card.vue";
import HdrCard from "@/components/work-card/hdr-card.vue";
import MaterialCard from "@/components/work-card/material-card.vue";
import AcademyCard from "@/components/work-card/academy-card.vue";
import Gaia48Card from "../../components/work-card/gaia48-card.vue";
export default {
  components: {
    ThumbsUp,
    WorksCard,
    HdrCard,
    MaterialCard,
    AcademyCard,
    Gaia48Card,
  },
  props: {
    isSelf: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      url: "https://pub-glb.cn-e1.acs-cdn.gaiamount.com",
      page: {
        pageIndex: 1,
        pageSize: 8,
        total: 0,
      },
      selectActive: 0,
      see: "",
      down: true,
      sort: "time",
      state: "reviewPassed",
      colorEnhancement: "",
      allowDownload: "",
      MemberType: "",
      courseType: "",
      areaId: "",
      areaList: [],
      loading: true,
      worksList: [], // 作品
      hdrsList: [], // hdr
      showsList: [], // 展映
      materialsList: [], // 素材
      courseList: [], // 学院教程
      courseCworksList: [], // 学院作品池
      gaia48List: [], // 48作品
    };
  },
  created() {
    this.getAreas();
    if (Number(this.$route.query.type) >= 0) {
      this.selectActive = Number(this.$route.query.type);
    }
  },
  methods: {
    reset() {
      this.see = "";
      this.courseType = "";
      this.colorEnhancement = "";
      this.allowDownload = "";
      this.sort = "time";
      this.MemberType = "";
      this.getList();
    },
    /**
     * 分站区域
     */
    getAreas() {
      getAreas().then((res) => {
        this.areaList = res.areaList;
        this.areaId = res.areaList[0].id;
      });
    },
    /**
     * 作品列表
     */
    collections(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        colorEnhancement: this.colorEnhancement,
        allowDownload: this.allowDownload,
        sort: this.sort,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      collections(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.worksList = res.worksCollections.map((el) => {
            return el.works;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * hdr列表
     */
    getHdrList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        see: this.see,
        sort: this.sort,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      getHdrList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.hdrsList = res.worksList;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 展映列表
     */
    getShowList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        see: this.see,
        sort: this.sort,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      getShowList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.showsList = res.worksList;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 素材列表
     */
    getPersonalCollectMaterial(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        ...{
          userId: this.id,
          MaterialType: this.MemberType,
          state: this.state,
        },
      };
      getPersonalCollectMaterial(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.materialsList = res.materials.map((el) => {
            return { material: el };
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 学院列表
     */
    personalCollect(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        ...{
          type: this.courseType,
        },
      };
      personalCollect(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.courseList = res.courseCollectionList.map((el) => {
            return el.course;
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 学院作品池
     */
    personalCworksList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        sort: this.sort,
        state: this.state,
      };
      personalCworksList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.courseCworksList = res.worksList;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 48列表
     */
    getPersonal48Works(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      const data = {
        ...this.page,
        AreaId: this.areaId,
        KeyWord: "",
        isSelf: this.isSelf,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      getPersonal48Works(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.gaia48List = res.works;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    flushPage(res) {
      this.page.pageIndex = res.page.pageIndex;
      this.page.pageSize = res.page.pageSize;
      this.page.total = res.page.total;
      setTimeout(() => {
        this.$forceUpdate();
      }, 0);
    },
    /**
     * 切换页面
     */
    selectClick(i) {
      this.selectActive = i;
      this.getList();
    },
    /**
     * 根据selectActive加载对应的列表
     */
    getList(pageIndex = 1) {
      // this.worksList = [];
      // this.hdrsList = [];
      // this.showsList = [];
      // this.materialsList = [];
      // this.gaia48List = [];
      this.page.pageSize = 8;
      if (this.selectActive === 0) {
        this.collections(pageIndex);
      } else if (this.selectActive === 1) {
        this.getHdrList(pageIndex);
      } else if (this.selectActive === 2) {
        this.getShowList(pageIndex);
      } else if (this.selectActive === 3) {
        this.getPersonalCollectMaterial(pageIndex);
      } else if (this.selectActive === 4) {
        this.personalCollect(pageIndex);
      } else if (this.selectActive === 5) {
        this.personalCworksList(pageIndex);
      } else if (this.selectActive === 6) {
        this.page.pageSize = 9;
        this.getPersonal48Works(pageIndex);
      }
    },
    /**
     * 打开审核列表的dialog
     */
    openReview() {
      this.manageVisible = !this.manageVisible;
      this.$router.push(`/center-manage?type=${this.selectActive}`);
    },
    /**
     * 进入创作组批量管理
     */
    openManage() {
      this.$router.push("/group-add");
    },
    /**
     * 新窗口打开url
     */
    open(url) {
      open(url);
    },
    /**
     * 素材卡片点击
     */
    materialClick(i, contentType) {
      let routeData = this.$router.resolve(
        `/gaia-material/detail/${i}?contentType=${contentType}`
      );
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.select-page {
  display: inline-block;
  padding: 0 0 10px;
  .item {
    float: left;
    width: 100px;
    height: 30px;
    background: #fff;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #666;
    line-height: 28px;
    text-align: center;
    user-select: none;
    cursor: pointer;
  }
  .item.active {
    background: linear-gradient(90deg, #ff5b67, #ff464c 100%, #ff464c 0);
    color: #fff;
  }
  .item:first-child {
    border-radius: 6px 0 0 6px;
  }
  .item:last-child {
    border-radius: 0 6px 6px 0;
  }
}
.all-works {
  width: 1300px;
  margin: 0 auto;
  padding: 0 50px 60px;
  .item {
    margin-right: 33px;
    margin-bottom: 30px;
  }
  .item:nth-child(4n + 5) {
    margin-right: 0;
  }
  .item2 {
    margin-right: 150px;
    margin-bottom: 30px;
  }
  .item2:nth-child(3n + 1) {
    margin-right: 0;
  }
}
.select {
  float: right;
}
.page {
  margin: -40px auto 0;
}
</style>
